import RadioGroup from './RadioGroup';
import '../styles/tripadvisor.css';

const TripadvisorCategorySelector = ({ value, onChange, label, disabled }) => {
  const tripadvisorOptions = [
    { label: 'All', value: 'all' },
    { label: 'Destinations', value: 'geos' },
    { label: 'Restaurants', value: 'restaurants' },
    { label: 'Hotels', value: 'hotels' },
    { label: 'Attractions', value: 'attractions' }
  ];
  
  const effectiveValue = value || 'geos';
  
  const handleChange = (newValue) => {
    onChange(newValue);
  };
  
  return (
    <div className="tripadvisor-category-selector">
      <div className="tripadvisor-category-label">
        <label>
          {label || 'Category'}
          <span className="required">*</span>
        </label>
      </div>
      <RadioGroup
        groupLabel="tripadvisorCategory"
        options={tripadvisorOptions}
        value={effectiveValue}
        onChange={handleChange}
        inline={true}
        disabled={disabled}
        radioContainerClassName="tripadvisor-category-option"
        containerStyles={{ display: 'flex', gap: '0.25rem 1rem', flexWrap: 'wrap' }}
      />
    </div>
  );
};

export default TripadvisorCategorySelector;